import { MOBILE_L_BP } from "@website-builder/utilities-index";
import styled from "styled-components";

export const BlogCategoriesWrapper = styled.div`
	margin-bottom: 24px;
	position: sticky;
	top: ${({ isHeaderSticky }) => (isHeaderSticky ? "144px" : "64px")};
	.blog-categories-mobile {
		display: none;

		.blog-categories-mobile-heading {
			margin: 0;
		}
		.blog-categories-mobile-content {
			padding: 0 0 24px 0;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-direction: column-reverse;
		.blog-categories-mobile {
			display: block;
		}
		.blog-categories-desktop {
			display: none;
		}
	}
`;

export const ListWrapper = styled.div`
	& > * {
		display: block !important;
		padding: 0;
		margin-top: 1.5rem;

		${({ mobileMode }) =>
			mobileMode &&
			`
      &:first-child {
        margin-top: 0;
      }
    `}

		.blog-category-link {
			p:hover {
				font-weight: var(--fw-haffer-xh-2);
			}
		}

		.blog-category-link-active {
			position: relative;

			p {
				padding-left: 1rem;
				font-weight: var(--fw-haffer-xh-2);
			}
		}

		.blog-category-link-active::before {
			content: "";
			position: absolute;
			left: 0;
			top: 50%;
			height: 1rem;
			width: 0.5rem;
			transform: translateY(-50%);
			background-color: var(--theme-primary);
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
		}
	}
`;
